import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from './LoadingSpinner';

const LoaderSection = ({ height = 200, width = 200, size, variant = 'primary' }) => {
  const spinnerSize = size || Math.round(Math.min(height, width) * 0.35);

  return (
    <div
      className="loaderSection"
      style={{ height, width, margin: 'auto' }}
    >
      <LoadingSpinner size={spinnerSize} variant={variant} />
    </div>
  );
};

LoaderSection.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  size: PropTypes.number,
  variant: PropTypes.oneOf(['primary', 'white', 'subtle']),
};

export default LoaderSection;
